import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

/**
 * ROUTE PERMISSION SYSTEM
 *
 * How to protect routes with permissions:
 *
 * 1. Add a `meta` field with `permission` property to the route:
 *    {
 *      path: "/rooms",
 *      name: "RoomsPage",
 *      component: RoomsPage,
 *      meta: { permission: "ROOMS.VIEW" }  // <-- Permission required
 *    }
 *
 * 2. Permission format: "MODULE.ACTION"
 *    - MODULE: ROOMS, USERS, AGENCIES, GIFTS, BD_MEMBERS, etc.
 *    - ACTION: VIEW (list page), SINGLE_VIEW (detail page), CREATE, UPDATE, DELETE
 *
 * 3. SUPER ADMIN and ADMIN automatically bypass all permission checks
 *
 * 4. Other users need the specific permission in their permissions array
 *
 * 5. If a user tries to access a route without permission, they are redirected to HomePage
 *
 * Examples:
 * - meta: { permission: "ROOMS.VIEW" }        // View rooms list
 * - meta: { permission: "ROOMS.CREATE" }      // Create new room
 * - meta: { permission: "ROOMS.SINGLE_VIEW" } // View single room details
 * - meta: { permission: "USERS.UPDATE" }      // Edit user
 * - meta: { permission: "GIFTS.DELETE" }      // Delete gift
 */

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";

// Banners
import BannersPage from "../views/banners/index.vue";
import BannerCreatePage from "../views/banners/create.vue";
import BannerIdPage from "../views/banners/id.vue";
// Events
import EventsPage from "../views/events/index.vue";
import EventCreatePage from "../views/events/create.vue";
import EventIdPage from "../views/events/id.vue";
// Rooms
import RoomsPage from "../views/rooms/index.vue";
import RoomCreatePage from "../views/rooms/create.vue";
import RoomIdPage from "../views/rooms/id.vue";
// Seat Configurations
import SeatConfigurationsPage from "../views/seat-configurations/index.vue";
import SeatConfigurationCreatePage from "../views/seat-configurations/create.vue";
import SeatConfigurationIdPage from "../views/seat-configurations/id.vue";
// RoomUsers
import RoomUsersPage from "../views/room-users/index.vue";
// import RoomCreatePage from "../views/rooms/create.vue";
// import RoomIdPage from "../views/rooms/id.vue";
// RoomSeats
import RoomSeatsPage from "../views/mic-seats/index.vue";
// import RoomSeatCreatePage from "../views/rooms/create.vue";
// import RoomSeatIdPage from "../views/rooms/id.vue";
// Gifts
import GiftsPage from "../views/gifts/index.vue";
import GiftCreatePage from "../views/gifts/create.vue";
import GiftIdPage from "../views/gifts/id.vue";
// UserGifts
import UserGiftsPage from "../views/user-gifts/index.vue";
// Agencys
import AgencysPage from "../views/agencies/index.vue";
import AgencyCreatePage from "../views/agencies/create.vue";
import AgencyIdPage from "../views/agencies/id.vue";
import AgencyUsersPage from "../views/agency-members/index.vue";
// Agency Members
import AgencyMembersPage from "../views/agency-members/index.vue";
import AgencyMemberCreatePage from "../views/agency-members/create.vue";
import AgencyMemberIdPage from "../views/agency-members/id.vue";
// Countries
import CountrysPage from "../views/countries/index.vue";
import CountryCreatePage from "../views/countries/create.vue";
import CountryIdPage from "../views/countries/id.vue";
//Notification
import NotificationsPage from "../views/notifications/index.vue";
import NotificationCreatePage from "../views/notifications/create.vue";
import NotificationIdPage from "../views/notifications/id.vue";
//Transaction
import TransactionsPage from "../views/transactions/index.vue";
import TransactionCreatePage from "../views/transactions/create.vue";
import TransactionIdPage from "../views/transactions/id.vue";
//GameLog
import GameLogsPage from "../views/game-logs/index.vue";
import GameLogCreatePage from "../views/game-logs/create.vue";
import GameLogIdPage from "../views/game-logs/id.vue";
//Post
import PostsPage from "../views/posts/index.vue";
import PostCreatePage from "../views/posts/create.vue";
import PostIdPage from "../views/posts/id.vue";
//PostComment
import PostCommentsPage from "../views/post-comments/index.vue";
import PostCommentCreatePage from "../views/post-comments/create.vue";
import PostCommentIdPage from "../views/post-comments/id.vue";
//FeedBack
import FeedBacksPage from "../views/feedbacks/index.vue";
import FeedBackCreatePage from "../views/feedbacks/create.vue";
import FeedBackIdPage from "../views/feedbacks/id.vue";
//Tickets
import TicketsPage from "../views/tickets/index.vue";
import TicketChatPage from "../views/tickets/chat.vue";
//Wallet
import WalletsPage from "../views/wallets/index.vue";
import WalletCreatePage from "../views/wallets/create.vue";
import WalletIdPage from "../views/wallets/id.vue";
// RechargeCoins
import RechargeCoinsPage from "../views/recharge-coins/index.vue";
import RechargeCoinCreatePage from "../views/recharge-coins/create.vue";
import RechargeCoinIdPage from "../views/recharge-coins/id.vue";
// VipLevels
import VipLevelsPage from "../views/vip-levels/index.vue";
import VipLevelCreatePage from "../views/vip-levels/create.vue";
import VipLevelIdPage from "../views/vip-levels/id.vue";
// VipSubscriptions
import VipSubscriptionsPage from "../views/vip-subscriptions/index.vue";
// import VipSubscriptionCreatePage from "../views/vip-subscriptions/create.vue";
// import VipSubscriptionIdPage from "../views/vip-subscriptions/id.vue";
// Levels
import LevelsPage from "../views/levels/index.vue";
import LevelCreatePage from "../views/levels/create.vue";
import LevelIdPage from "../views/levels/id.vue";
//Diamond Exchanges
import DiamondExchangesPage from "../views/diamond-exchanges/index.vue";
//UserBlockLists
import UserBlockListsPage from "../views/user-blocklists/index.vue";
//Lucky Wheels
import LuckyWheelsPage from "../views/lucky-wheels/index.vue";
import LuckyWheelItemsPage from "../views/lucky-wheels/items.vue";
import LuckyWheelSpinPage from "../views/lucky-wheels/spin.vue";
import LuckyWheelHistoryPage from "../views/lucky-wheels/history.vue";
//RoomNotification
import RoomNotificationsPage from "../views/room-notifications/index.vue";
import RoomNotificationCreatePage from "../views/room-notifications/create.vue";

//StoreItem
import StoreItemsPage from "../views/store-items/index.vue";
import StoreItemCreatePage from "../views/store-items/create.vue";
import StoreItemIdPage from "../views/store-items/id.vue";
//Badge
import BadgesPage from "../views/badges/index.vue";
import BadgeCreatePage from "../views/badges/create.vue";
import BadgeIdPage from "../views/badges/id.vue";
//User Badge
import UserBadgesPage from "../views/user-badges/index.vue";
//Reward
import RewardsPage from "../views/rewards/index.vue";
import RewardCreatePage from "../views/rewards/create.vue";
import RewardIdPage from "../views/rewards/id.vue";
//User Reward
import UserRewardsPage from "../views/user-rewards/index.vue";
//UserBackpack
import UserBackpacksPage from "../views/user-backpacks/index.vue";
//Policy
import PoliciesPage from "../views/policies/index.vue";
import PolicyCreatePage from "../views/policies/create.vue";
import PolicyIdPage from "../views/policies/id.vue";
//VipPrivileges
import VipPrivilegesPage from "../views/vip-privileges/index.vue";
import VipPrivilegeCreatePage from "../views/vip-privileges/create.vue";
import VipPrivilegeIdPage from "../views/vip-privileges/id.vue";
//UserPositions
import UserPositionsPage from "../views/user-positions/index.vue";
import UserPositionCreatePage from "../views/user-positions/create.vue";
import UserPositionIdPage from "../views/user-positions/id.vue";
//Roombackgrounds
import RoombackgroundsPage from "../views/room-backgrounds/index.vue";
import RoombackgroundCreatePage from "../views/room-backgrounds/create.vue";
import RoombackgroundIdPage from "../views/room-backgrounds/id.vue";
//BDMembers
import BDMembersPage from "../views/bd-members/index.vue";
import BDMemberCreatePage from "../views/bd-members/create.vue";
import BDMemberIdPage from "../views/bd-members/id.vue";
//CoinSellerMerchants
import CoinSellerMerchantsPage from "../views/coinseller-merchants/index.vue";
import CoinSellerMerchantCreatePage from "../views/coinseller-merchants/create.vue";
import CoinSellerMerchantIdPage from "../views/coinseller-merchants/id.vue";
//Chats
import ChatsPage from "../views/chats/index.vue";
//WeeklyRoomRewards
import WeeklyRoomRewardsPage from "../views/weekly_room_rewards/index.vue";
import WeeklyRoomRewardCreatePage from "../views/weekly_room_rewards/create.vue";
import WeeklyRoomRewardIdPage from "../views/weekly_room_rewards/id.vue";
//RechargedBenefits
import RechargedBenefitsPage from "../views/recharged-benefits/index.vue";
import RechargedBenefitCreatePage from "../views/recharged-benefits/create.vue";
import RechargedBenefitIdPage from "../views/recharged-benefits/id.vue";
//WeeklyRewards
import WeeklyRewardsPage from "../views/weekly-rewards/index.vue";
import WeeklyRewardCreatePage from "../views/weekly-rewards/create.vue";
import WeeklyRewardIdPage from "../views/weekly-rewards/id.vue";
import WeeklyRewardCategoryPage from "../views/weekly-rewards/category-rewards.vue";
import WeeklyRewardCategoryEditPage from "../views/weekly-rewards/category-edit.vue";
//OfficialWithdrawals
import OfficialWithdrawalsPage from "../views/official-withdrawals/index.vue";
import OfficialWithdrawalCreatePage from "../views/official-withdrawals/create.vue";
import OfficialWithdrawalIdPage from "../views/official-withdrawals/id.vue";
const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
        meta: { permission: "USERS.VIEW" },
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
        meta: { permission: "USERS.CREATE" },
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
        meta: { permission: "USERS.CREATE" },
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
        meta: { permission: "USERS.SINGLE_VIEW" },
      },

      // Batch Medals
      {
        path: "/batch_medals",
        name: "BatchMedalsPage",
        component: () => import("../views/batch_medals/index.vue"),
      },
      {
        path: "/batch_medals/create",
        name: "BatchMedalCreatePage",
        component: () => import("../views/batch_medals/create.vue"),
      },
      {
        path: "/batch_medals/:batchMedalId",
        name: "BatchMedalEditPage",
        component: () => import("../views/batch_medals/id.vue"),
      },
      {
        path: "/batch_medals/deleted",
        name: "DeletedBatchMedalsPage",
        component: () => import("../views/batch_medals/index.vue"),
      },

      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },

      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
      },
      // Banners
      {
        path: "/banners",
        name: "BannersPage",
        component: BannersPage,
      },
      {
        path: "/banners/create",
        name: "BannerCreatePage",
        component: BannerCreatePage,
      },
      {
        path: "/banners/:bannerId",
        name: "BannerIdPage",
        component: BannerIdPage,
      },
      // Events
      {
        path: "/events",
        name: "EventsPage",
        component: EventsPage,
      },
      {
        path: "/events/create",
        name: "EventCreatePage",
        component: EventCreatePage,
      },
      {
        path: "/events/:eventId",
        name: "EventIdPage",
        component: EventIdPage,
      },
      // Rooms
      {
        path: "/rooms",
        name: "RoomsPage",
        component: RoomsPage,
        meta: { permission: "ROOMS.VIEW" },
      },
      {
        path: "/rooms/create",
        name: "RoomCreatePage",
        component: RoomCreatePage,
        meta: { permission: "ROOMS.CREATE" },
      },
      {
        path: "/rooms/:roomId",
        name: "RoomIdPage",
        component: RoomIdPage,
        meta: { permission: "ROOMS.SINGLE_VIEW" },
      },
      //Room User
      {
        path: "/rooms/:roomId/room-users",
        name: "RoomUsersPage",
        component: RoomUsersPage,
      },
      //Room Seats
      {
        path: "/rooms/:roomId/room-seats",
        name: "RoomSeatsPage",
        component: RoomSeatsPage,
      },
      // Seat Configurations
      {
        path: "/seat-configurations",
        name: "SeatConfigurationsPage",
        component: SeatConfigurationsPage,
        meta: { permission: "SEAT_CONFIGURATIONS.VIEW" },
      },
      {
        path: "/seat-configurations/create",
        name: "SeatConfigurationCreatePage",
        component: SeatConfigurationCreatePage,
        meta: { permission: "SEAT_CONFIGURATIONS.CREATE" },
      },
      {
        path: "/seat-configurations/:id",
        name: "SeatConfigurationIdPage",
        component: SeatConfigurationIdPage,
        meta: { permission: "SEAT_CONFIGURATIONS.UPDATE" },
      },
      // Gifts
      {
        path: "/gifts",
        name: "GiftsPage",
        component: GiftsPage,
        meta: { permission: "GIFTS.VIEW" },
      },
      {
        path: "/gifts/create",
        name: "GiftCreatePage",
        component: GiftCreatePage,
        meta: { permission: "GIFTS.CREATE" },
      },
      {
        path: "/gifts/:giftId",
        name: "GiftIdPage",
        component: GiftIdPage,
        meta: { permission: "GIFTS.SINGLE_VIEW" },
      },
      // User Gifts
      {
        path: "/gifts/:giftId/user-gifts",
        name: "UserGiftsPage",
        component: UserGiftsPage,
      },
      // Agency
      {
        path: "/agencies",
        name: "AgencysPage",
        component: AgencysPage,
        meta: { permission: "AGENCIES.VIEW" },
      },
      {
        path: "/agencies/create",
        name: "AgencyCreatePage",
        component: AgencyCreatePage,
        meta: { permission: "AGENCIES.CREATE" },
      },
      {
        path: "/agencies/:agencyId",
        name: "AgencyIdPage",
        component: AgencyIdPage,
        meta: { permission: "AGENCIES.SINGLE_VIEW" },
      },
      //Room User
      {
        path: "/agecncies/:agencyId/agency-users",
        name: "AgencyUsersPage",
        component: AgencyUsersPage,
      },
      // Agency Members
      {
        path: "/agency-members",
        name: "AgencyMembersPage",
        component: AgencyMembersPage,
      },
      {
        path: "/agency-members/:agencyId/create",
        name: "AgencyMemberCreatePage",
        component: AgencyMemberCreatePage,
      },
      {
        path: "/agency-members/:agencyMemberId",
        name: "AgencyMemberIdPage",
        component: AgencyMemberIdPage,
      },
      // Countries
      {
        path: "/countries",
        name: "CountrysPage",
        component: CountrysPage,
      },
      {
        path: "/countries/create",
        name: "CountryCreatePage",
        component: CountryCreatePage,
      },
      {
        path: "/countries/:countriesId",
        name: "CountryIdPage",
        component: CountryIdPage,
      },
      //Notification
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
      },
      {
        path: "/notifications/create",
        name: "NotificationCreatePage",
        component: NotificationCreatePage,
      },
      {
        path: "/notifications/:notificationId",
        name: "NotificationIdPage",
        component: NotificationIdPage,
      },
      //Transaction
      {
        path: "/transactions",
        name: "TransactionsPage",
        component: TransactionsPage,
      },
      {
        path: "/transactions/create",
        name: "TransactionCreatePage",
        component: TransactionCreatePage,
      },
      {
        path: "/transactions/:transactionId",
        name: "TransactionIdPage",
        component: TransactionIdPage,
      },
      //GameLog
      {
        path: "/game-logs",
        name: "GameLogsPage",
        component: GameLogsPage,
      },
      {
        path: "/game-logs/create",
        name: "GameLogCreatePage",
        component: GameLogCreatePage,
      },
      {
        path: "/game-logs/:gameLogId",
        name: "GameLogIdPage",
        component: GameLogIdPage,
      },
      //Posts
      {
        path: "/posts",
        name: "PostsPage",
        component: PostsPage,
      },
      {
        path: "/posts/create",
        name: "PostCreatePage",
        component: PostCreatePage,
      },
      {
        path: "/posts/:gameLogId",
        name: "PostIdPage",
        component: PostIdPage,
      },
      //PostComments
      {
        path: "/post-comments",
        name: "PostCommentsPage",
        component: PostCommentsPage,
      },
      {
        path: "/post-comments/create",
        name: "PostCommentCreatePage",
        component: PostCommentCreatePage,
      },
      {
        path: "/post-comments/:postCommentId",
        name: "PostCommentIdPage",
        component: PostCommentIdPage,
      },
      //FeedBacks
      {
        path: "/feedbacks",
        name: "FeedBacksPage",
        component: FeedBacksPage,
      },
      {
        path: "/feedbacks/create",
        name: "FeedBackCreatePage",
        component: FeedBackCreatePage,
      },
      {
        path: "/feedbacks/:feedbackId",
        name: "FeedBackIdPage",
        component: FeedBackIdPage,
      },
      //Tickets
      {
        path: "/tickets",
        name: "TicketsPage",
        component: TicketsPage,
      },
      {
        path: "/tickets/:id/chat",
        name: "TicketChatPage",
        component: TicketChatPage,
      },
      //Wallets
      {
        path: "/wallets",
        name: "WalletsPage",
        component: WalletsPage,
      },
      {
        path: "/wallets/create",
        name: "WalletCreatePage",
        component: WalletCreatePage,
      },
      {
        path: "/wallets/:walletId",
        name: "WalletIdPage",
        component: WalletIdPage,
      },
      // RechargeCoin
      {
        path: "/recharge-coins",
        name: "RechargeCoinsPage",
        component: RechargeCoinsPage,
      },
      {
        path: "/recharge-coins/create",
        name: "RechargeCoinCreatePage",
        component: RechargeCoinCreatePage,
      },
      {
        path: "/recharge-coins/:rechargeCoinId",
        name: "RechargeCoinIdPage",
        component: RechargeCoinIdPage,
      },
      //VipLevels
      {
        path: "/vip-levels",
        name: "VipLevelsPage",
        component: VipLevelsPage,
      },
      {
        path: "/vip-levels/create",
        name: "VipLevelCreatePage",
        component: VipLevelCreatePage,
      },
      {
        path: "/vip-levels/:vipLevelId",
        name: "VipLevelIdPage",
        component: VipLevelIdPage,
      },
      //VipLevels
      {
        path: "/vip-subscriptions",
        name: "VipSubscriptionsPage",
        component: VipSubscriptionsPage,
      },
      // {
      //   path: "/vip-subscriptions/create",
      //   name: "VipSubscriptionCreatePage",
      //   component: VipSubscriptionCreatePage,
      // },
      // {
      //   path: "/vip-subscriptions/:vipSubscriptionsId",
      //   name: "VipSubscriptionIdPage",
      //   component: VipSubscriptionIdPage,
      // },
      // Levels
      {
        path: "/levels",
        name: "LevelsPage",
        component: LevelsPage,
      },
      {
        path: "/levels/create",
        name: "LevelCreatePage",
        component: LevelCreatePage,
      },
      {
        path: "/levels/:levelId",
        name: "LevelIdPage",
        component: LevelIdPage,
      },
      // Diamond-Exchange
      {
        path: "/diamond-exchanges",
        name: "DiamondExchangesPage",
        component: DiamondExchangesPage,
      },
      // User Block Lists
      {
        path: "/user-block-lists",
        name: "UserBlockListsPage",
        component: UserBlockListsPage,
      },
      //RoomNotification
      {
        path: "/room-notifications",
        name: "RoomNotificationsPage",
        component: RoomNotificationsPage,
      },
      {
        path: "/room-notifications/create",
        name: "RoomNotificationCreatePage",
        component: RoomNotificationCreatePage,
      },
      // {
      //   path: "/room-notifications/:roomNotificationId",
      //   name: "RoomNotificationIdPage",
      //   component: RoomNotificationIdPage,
      // },
      //StoreItem
      {
        path: "/store-items",
        name: "StoreItemsPage",
        component: StoreItemsPage,
      },
      {
        path: "/store-items/create",
        name: "StoreItemCreatePage",
        component: StoreItemCreatePage,
      },
      {
        path: "/store-items/category/:categoryId",
        name: "StoreItemCategoryEditPage",
        component: StoreItemIdPage,
      },
      {
        path: "/store-items/:storeItemId",
        name: "StoreItemIdPage",
        component: StoreItemIdPage,
      },
      //UserBadge
      {
        path: "/user-badges",
        name: "UserBadgesPage",
        component: UserBadgesPage,
      },
      //Badge
      {
        path: "/badges",
        name: "BadgesPage",
        component: BadgesPage,
      },
      {
        path: "/badges/create",
        name: "BadgeCreatePage",
        component: BadgeCreatePage,
      },
      {
        path: "/badges/:badgeId",
        name: "BadgeIdPage",
        component: BadgeIdPage,
      },
      //UserReward
      {
        path: "/user-rewards",
        name: "UserRewardsPage",
        component: UserRewardsPage,
      },
      //Reward
      {
        path: "/rewards",
        name: "RewardsPage",
        component: RewardsPage,
      },
      {
        path: "/rewards/create",
        name: "RewardCreatePage",
        component: RewardCreatePage,
      },
      {
        path: "/rewards/:weekId",
        name: "RewardIdPage",
        component: RewardIdPage,
      },
      //UserReward
      {
        path: "/user-backpacks",
        name: "UserBackpacksPage",
        component: UserBackpacksPage,
      },
      //Policy
      {
        path: "/policies",
        name: "PoliciesPage",
        component: PoliciesPage,
      },
      {
        path: "/policies/create",
        name: "PolicyCreatePage",
        component: PolicyCreatePage,
      },
      {
        path: "/policies/:policyId",
        name: "PolicyIdPage",
        component: PolicyIdPage,
      },
      //Policy
      {
        path: "/vip-privileges",
        name: "VipPrivilegesPage",
        component: VipPrivilegesPage,
      },
      {
        path: "/vip-privileges/create",
        name: "VipPrivilegeCreatePage",
        component: VipPrivilegeCreatePage,
      },
      {
        path: "/vip-privileges/:privilegeId",
        name: "VipPrivilegeIdPage",
        component: VipPrivilegeIdPage,
      },
      //Policy
      {
        path: "/user-positions",
        name: "UserPositionsPage",
        component: UserPositionsPage,
      },
      {
        path: "/user-positions/create",
        name: "UserPositionCreatePage",
        component: UserPositionCreatePage,
      },
      {
        path: "/user-positions/:userPositionId",
        name: "UserPositionIdPage",
        component: UserPositionIdPage,
      },
      //Roombackgrounds
      {
        path: "/room-backgrounds",
        name: "RoombackgroundsPage",
        component: RoombackgroundsPage,
      },
      {
        path: "/room-backgrounds/create",
        name: "RoombackgroundCreatePage",
        component: RoombackgroundCreatePage,
      },
      {
        path: "/room-backgrounds/:backgroundId",
        name: "RoombackgroundIdPage",
        component: RoombackgroundIdPage,
      },
      //BDMembers
      {
        path: "/bd-members",
        name: "BDMembersPage",
        component: BDMembersPage,
        meta: { permission: "BD_MEMBERS.VIEW" },
      },
      {
        path: "/bd-members/create",
        name: "BDMemberCreatePage",
        component: BDMemberCreatePage,
        meta: { permission: "BD_MEMBERS.CREATE" },
      },
      {
        path: "/bd-members/:bdMemberId",
        name: "BDMemberIdPage",
        component: BDMemberIdPage,
        meta: { permission: "BD_MEMBERS.SINGLE_VIEW" },
      },
      //CoinSellerMerchants
      {
        path: "/coinseller-merchants",
        name: "CoinSellerMerchantsPage",
        component: CoinSellerMerchantsPage,
      },
      {
        path: "/coinseller-merchants/create",
        name: "CoinSellerMerchantCreatePage",
        component: CoinSellerMerchantCreatePage,
      },
      {
        path: "/coinseller-merchants/:rechargeAgentId",
        name: "CoinSellerMerchantIdPage",
        component: CoinSellerMerchantIdPage,
      },
      //Lucky Wheels
      {
        path: "/lucky-wheels",
        name: "LuckyWheelsPage",
        component: LuckyWheelsPage,
        meta: { permission: "LUCKY_WHEELS.VIEW" },
      },
      {
        path: "/lucky-wheels/:id/items",
        name: "LuckyWheelItemsPage",
        component: LuckyWheelItemsPage,
        meta: { permission: "LUCKY_WHEELS.VIEW" },
      },
      {
        path: "/lucky-wheels/spin",
        name: "LuckyWheelSpinPage",
        component: LuckyWheelSpinPage,
      },
      {
        path: "/lucky-wheels/history",
        name: "LuckyWheelHistoryPage",
        component: LuckyWheelHistoryPage,
      },
      //Chats
      {
        path: "/chats",
        name: "ChatsPage",
        component: ChatsPage,
      },
      // WeeklyRoomRewards
      {
        path: "/weekly_room_rewards",
        name: "WeeklyRoomRewardsPage",
        component: WeeklyRoomRewardsPage,
      },
      {
        path: "/weekly_room_rewards/create",
        name: "WeeklyRoomRewardCreatePage",
        component: WeeklyRoomRewardCreatePage,
      },
      {
        path: "/weekly_room_rewards/:weeklyRoomRewardId",
        name: "WeeklyRoomRewardIdPage",
        component: WeeklyRoomRewardIdPage,
      },
      // WeeklyRewards
      {
        path: "/weekly-rewards",
        name: "WeeklyRewardsPage",
        component: WeeklyRewardsPage,
      },
      {
        path: "/weekly-rewards/create",
        name: "WeeklyRewardCreatePage",
        component: WeeklyRewardCreatePage,
      },
      {
        path: "/weekly-rewards/category/:categoryId",
        name: "WeeklyRewardCategoryPage",
        component: WeeklyRewardCategoryPage,
      },
      {
        path: "/weekly-rewards/category/:categoryId/edit",
        name: "WeeklyRewardCategoryEditPage",
        component: WeeklyRewardCategoryEditPage,
      },
      {
        path: "/weekly-rewards/:weeklyRewardId",
        name: "WeeklyRewardIdPage",
        component: WeeklyRewardIdPage,
      },
      // RechargedBenefits
      {
        path: "/rechargedbenefits",
        name: "rechargedbenefits",
        component: RechargedBenefitsPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/rechargedbenefits/create",
        name: "rechargedbenefits-create",
        component: RechargedBenefitCreatePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/rechargedbenefits/:id",
        name: "rechargedbenefits-edit",
        component: RechargedBenefitIdPage,
        meta: { requiresAuth: true },
      },
      // OfficialWithdrawals
      {
        path: "/official-withdrawals",
        name: "OfficialWithdrawalsPage",
        component: OfficialWithdrawalsPage,
      },
      {
        path: "/official-withdrawals/create",
        name: "OfficialWithdrawalCreatePage",
        component: OfficialWithdrawalCreatePage,
      },
      {
        path: "/official-withdrawals/:withdrawalId",
        name: "OfficialWithdrawalIdPage",
        component: OfficialWithdrawalIdPage,
      },
      // Reward Events (Admin)
      {
        path: "/reward-events",
        name: "RewardEventsPage",
        component: () => import("../views/reward-events/index.vue"),
      },
      {
        path: "/reward-events/create",
        name: "RewardEventCreatePage",
        component: () => import("../views/reward-events/create.vue"),
      },
      {
        path: "/reward-events/:eventId",
        name: "RewardEventIdPage",
        component: () => import("../views/reward-events/id.vue"),
      },
      // User Rewards Activity (User-facing)
      {
        path: "/rewards-activity",
        name: "UserRewardsActivityPage",
        component: () => import("../views/user-rewards-activity/index.vue"),
      },
      // Weekly Star Ranking (User-facing)
      {
        path: "/weekly-star",
        name: "WeeklyStarPage",
        component: () => import("../views/weekly-star/index.vue"),
      },
      {
        path: "/weekly-star/:slug",
        name: "WeeklyStarSlugPage",
        component: () => import("../views/weekly-star/index.vue"),
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/**
 * Check if user has permission to access route
 * @param {string} permission - Required permission
 * @returns {boolean}
 */
function canAccessRoute(permission) {
  if (!permission) return true; // No permission required

  const user = store.state.auth.user;
  const permissions = store.state.auth.permissions;

  // SUPER ADMIN and ADMIN bypass all permission checks
  if (user && user.roles && user.roles.length > 0) {
    const roleName = user.roles[0].name;
    if (roleName === "SUPER ADMIN" || roleName === "ADMIN") {
      return true;
    }
  }

  // Check if permission exists in user's permissions array
  return permissions && permissions.includes(permission);
}

router.beforeEach((to, from, next) => {
  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("1");
    if (store.getters["auth/authenticated"]) {
      console.log("2");
      let company_id = store.getters["auth/company"].id;
      if (company_id) {
        console.log("3");
        console.log(company_id);
      }
      return next({
        name: "HomePage",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("4");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("5");
    return next({
      name: "HomePage",
    });
  } else {
    // Check permission if route requires it
    if (to.meta && to.meta.permission) {
      if (!canAccessRoute(to.meta.permission)) {
        console.log(
          `Access denied: Missing permission "${to.meta.permission}"`
        );
        return next({
          name: "HomePage",
        });
      }
    }
    next();
  }
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
